import { useContext } from 'react';

import { dealBuilderContext } from './dealBuilderContext';

export const useDealBuilderContext = () => {
  const context = useContext(dealBuilderContext);

  if (!context) throw new Error('useDealBuilderContext must be used within a DealBuilderContextProvider');

  return context;
};
